(function() {
  var EncodingUtils, HybridOption, PlantingPlanHybrid,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  HybridOption = App.loadClass("grower::classes/placement/HybridOption");

  PlantingPlanHybrid = App.loadClass("grower::classes/placement/PlantingPlanHybrid");

  EncodingUtils = App.loadClass("core::utils/encoding");

  exports.Field = function(field, parent) {
    var ref, ref1, self;
    if (field == null) {
      field = {};
    }
    self = this;
    this.getParent = function() {
      return parent;
    };
    this.handleResponse = function(response) {
      var has_refuge_options, ho, hybrid, hybridsTaffy, j, k, l, len, len1, len2, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ro;
      if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
        hybridsTaffy = parent.spp.taffyObjects.hybrids;
        has_refuge_options = false;
        ref1 = response.data.hybrids;
        for (j = 0, len = ref1.length; j < len; j++) {
          hybrid = ref1[j];
          ho = new HybridOption(hybrid, hybridsTaffy);
          self.hybrids.push(ho);
          ho.requires_refuge = ho.ref_pct > 0;
          if (ho.id === ((ref2 = self.hybrid_selection()) != null ? ref2.id : void 0)) {
            self.hybrid_selection(ho);
          }
          if (ho.refuge_options.length) {
            has_refuge_options = true;
            ref3 = ho.refuge_options;
            for (k = 0, len1 = ref3.length; k < len1; k++) {
              ro = ref3[k];
              if (ro.id === ((ref4 = self.refuge_selection()) != null ? ref4.id : void 0)) {
                self.refuge_selection(ro);
              }
            }
          }
        }
        if (!has_refuge_options) {
          self.refuge_selection(null);
        }
        if (response.data.low_yield_hybrids.length) {
          ref5 = response.data.low_yield_hybrids;
          for (l = 0, len2 = ref5.length; l < len2; l++) {
            hybrid = ref5[l];
            ho = new HybridOption(hybrid, hybridsTaffy);
            self.lowYieldHybrids.push(ho);
            if (ho.id === ((ref6 = self.low_yield_hybrid_selection()) != null ? ref6.id : void 0)) {
              self.low_yield_hybrid_selection(ho);
            }
          }
        } else {
          self.low_yield_hybrid_selection(null);
        }
        self.showSpinner(false);
        return self.showError(false);
      } else if (((ref7 = response.status) != null ? ref7.type : void 0) === 'error') {
        self.showSpinner(false);
        return self.showError(true);
      }
    };
    this.setSurveyDetails = function(details) {
      var detail, is_array, j, k, key, left_height, len, len1, results1, total_height, value;
      this.left_column = [];
      this.right_column = [];
      if (!(details != null ? details.length : void 0)) {
        return;
      }
      total_height = 0;
      for (j = 0, len = details.length; j < len; j++) {
        detail = details[j];
        key = detail[0], value = detail[1];
        total_height += value instanceof Array ? 3 : 1;
      }
      left_height = 0;
      results1 = [];
      for (k = 0, len1 = details.length; k < len1; k++) {
        detail = details[k];
        key = detail[0], value = detail[1];
        is_array = value instanceof Array;
        if (_.isString(value)) {
          value = value.replace('<br>', ' ');
        }
        detail = {
          key: key,
          value: value
        };
        if (!is_array && left_height < total_height / 2) {
          this.left_column.push(detail);
          results1.push(left_height += 1);
        } else if (is_array && left_height < (total_height - 4) / 2) {
          this.left_column.push(detail);
          results1.push(left_height += 3);
        } else {
          results1.push(this.right_column.push(detail));
        }
      }
      return results1;
    };
    this.saveSeedSelection = function(callback) {
      var hybrid, lowYieldHybrid, postParams, refuge;
      if (callback == null) {
        callback = null;
      }
      hybrid = self.hybrid_selection();
      lowYieldHybrid = self.low_yield_hybrid_selection();
      refuge = self.refuge_selection();
      postParams = {
        id: parent.spp_id,
        result_id: parent.results_id,
        field_id: self.id
      };
      if (hybrid != null) {
        postParams.hybrid_id = hybrid.id;
      }
      if (lowYieldHybrid != null) {
        postParams.low_yield_hybrid_id = lowYieldHybrid.id;
      }
      if (refuge != null) {
        postParams.refuge_id = refuge.id;
      }
      return $.post('backend/grower/placement/spp/save-seed-selection', postParams, function(response) {
        return typeof callback === "function" ? callback() : void 0;
      });
    };
    this.setPlantingPlan = function(planting_id, results, hybridsTaffy, selectionsKO, doAJAX) {
      var ho, hybrid, id, j, len, plantingPlanHybrid, postParams, refuge, refuge_options, result, ro, sppField;
      self.planting_plan_id(planting_id);
      self.rx_plan_id(null);
      self.hidden_planting_plan_id(null);
      hybrid = results[0];
      refuge = results[1];
      if (hybrid != null) {
        id = parseInt(hybrid.id);
        ho = (new TAFFY(self.hybrids()))({
          id: id
        }).first();
        if (!ho) {
          refuge_options = refuge != null ? [refuge] : [];
          ho = new HybridOption(hybrid, hybridsTaffy, false, refuge_options);
        }
        self.hybrid_selection(ho);
        if (refuge != null) {
          id = parseInt(refuge.id);
          ro = (new TAFFY(ho.refuge_options))({
            id: id
          }).first();
          if (!ro) {
            ro = new HybridOption(refuge, hybridsTaffy, true);
          }
          self.refuge_selection(ro);
        } else {
          self.refuge_selection(null);
        }
      } else {
        self.hybrid_selection(null);
        self.refuge_selection(null);
      }
      self.low_yield_hybrid_selection(null);
      self.saveSeedSelection();
      sppField = parent.spp.taffyObjects.fields({
        id: parseInt(self.id)
      }).first();
      sppField.planting_plan_id = self.planting_plan_id();
      self.plannedHybrids.removeAll();
      sppField.planting_plan_hybrids = [];
      for (j = 0, len = results.length; j < len; j++) {
        result = results[j];
        plantingPlanHybrid = new PlantingPlanHybrid(result, planting_id);
        self.plannedHybrids.push(plantingPlanHybrid);
        sppField.planting_plan_hybrids.push(plantingPlanHybrid);
      }
      selectionsKO.setPlan(self.id, self.plannedHybrids());
      if (doAJAX) {
        postParams = {
          id: parent.spp_id,
          result_id: parent.results_id,
          field_id: self.id,
          pp_id: planting_id
        };
        return $.post('backend/grower/placement/spp/set-planting-plan', postParams, function(response) {
          return void 0;
        });
      }
    };
    this.setRxPlan = function(rx_id, planting_id, results, hybridsTaffy, selectionsKO, doAJAX) {
      var ho, hybrid, id, j, k, l, len, len1, len2, low_yield_hybrid, lyho, plantingPlanHybrid, postParams, refuge, refuge_options, result, ro, sppField;
      self.planting_plan_id(null);
      self.rx_plan_id(rx_id);
      self.hidden_planting_plan_id(planting_id);
      if (results.length > 0) {
        hybrid = null;
        low_yield_hybrid = null;
        refuge = null;
        for (j = 0, len = results.length; j < len; j++) {
          result = results[j];
          if (result.is_high_yield) {
            hybrid = result;
          }
          if (result.is_low_yield) {
            low_yield_hybrid = result;
          }
          if (result.is_refuge) {
            refuge = result;
          }
        }
        if (hybrid == null) {
          for (k = 0, len1 = results.length; k < len1; k++) {
            result = results[k];
            if (!result.is_high_yield && !result.is_refuge) {
              hybrid = result;
              break;
            }
          }
        }
        if (hybrid != null) {
          id = parseInt(hybrid.id);
          ho = (new TAFFY(self.hybrids()))({
            id: id
          }).first();
          if (!ho) {
            refuge_options = refuge != null ? [refuge] : [];
            ho = new HybridOption(hybrid, hybridsTaffy, false, refuge_options);
          }
          self.hybrid_selection(ho);
          if (low_yield_hybrid != null) {
            id = parseInt(low_yield_hybrid.id);
            lyho = (new TAFFY(self.hybrids()))({
              id: id
            }).first();
            if (!lyho) {
              lyho = new HybridOption(low_yield_hybrid, hybridsTaffy, false, []);
            }
            self.low_yield_hybrid_selection(lyho);
          } else {
            self.low_yield_hybrid_selection(null);
          }
          if (refuge != null) {
            id = parseInt(refuge.id);
            ro = (new TAFFY(ho.refuge_options))({
              id: id
            }).first();
            if (!ro) {
              ro = new HybridOption(refuge, hybridsTaffy, true);
            }
            self.refuge_selection(ro);
          } else {
            self.refuge_selection(null);
          }
        } else {
          self.hybrid_selection(null);
          self.low_yield_hybrid_selection(null);
          self.refuge_selection(null);
        }
      } else {
        self.hybrid_selection(null);
        self.low_yield_hybrid_selection(null);
        self.refuge_selection(null);
      }
      self.saveSeedSelection();
      sppField = parent.spp.taffyObjects.fields({
        id: parseInt(self.id)
      }).first();
      sppField.rx_plan_id = self.rx_plan_id();
      sppField.hidden_planting_plan_id = self.hidden_planting_plan_id();
      self.plannedHybrids.removeAll();
      sppField.rx_plan_hybrids = [];
      for (l = 0, len2 = results.length; l < len2; l++) {
        result = results[l];
        plantingPlanHybrid = new PlantingPlanHybrid(result, planting_id);
        self.plannedHybrids.push(plantingPlanHybrid);
        sppField.rx_plan_hybrids.push(plantingPlanHybrid);
      }
      selectionsKO.setPlan(self.id, self.plannedHybrids());
      if (doAJAX) {
        postParams = {
          id: parent.spp_id,
          result_id: parent.results_id,
          field_id: self.id,
          rx_id: rx_id
        };
        return $.post('backend/grower/placement/spp/set-rx-plan', postParams, function(response) {
          return void 0;
        });
      }
    };
    this.getOptionClass = function() {
      if ((self.planting_plan_id() != null) || (self.rx_plan_id() != null)) {
        return 'placement-finished-fields';
      }
    };
    this.getNextHybrids = function(checkOnly) {
      var arr, ind;
      if (checkOnly == null) {
        checkOnly = false;
      }
      arr = self.hybrids();
      ind = self.hybridSliceIndex;
      return self._increment(arr, ind, checkOnly);
    };
    this.getPrevHybrids = function(checkOnly) {
      var arr, ind;
      if (checkOnly == null) {
        checkOnly = false;
      }
      arr = self.hybrids();
      ind = self.hybridSliceIndex;
      return self._decrement(arr, ind, checkOnly);
    };
    this.selectHybrid = function(hybrid) {
      var ref;
      if (hybrid.id === ((ref = self.hybrid_selection()) != null ? ref.id : void 0)) {
        self.hybrid_selection(null);
      } else {
        self.hybrid_selection(hybrid);
      }
      self.refuge_selection(null);
      self.refugeSliceIndex(0);
      return self.saveSeedSelection();
    };
    this.getNextLowYieldHybrids = function(checkOnly) {
      var arr, ind;
      if (checkOnly == null) {
        checkOnly = false;
      }
      arr = self.lowYieldHybrids();
      ind = self.lowYieldHybridSliceIndex;
      return self._increment(arr, ind, checkOnly);
    };
    this.getPrevLowYieldHybrids = function(checkOnly) {
      var arr, ind;
      if (checkOnly == null) {
        checkOnly = false;
      }
      arr = self.lowYieldHybrids();
      ind = self.lowYieldHybridSliceIndex;
      return self._decrement(arr, ind, checkOnly);
    };
    this.selectLowYieldHybrid = function(hybrid) {
      var ref;
      if (hybrid.id === ((ref = self.low_yield_hybrid_selection()) != null ? ref.id : void 0)) {
        self.low_yield_hybrid_selection(null);
      } else {
        self.low_yield_hybrid_selection(hybrid);
      }
      return self.saveSeedSelection();
    };
    this.getNextRefuges = function(checkOnly) {
      var arr, hybrid, ind;
      if (checkOnly == null) {
        checkOnly = false;
      }
      hybrid = self.hybrid_selection();
      arr = hybrid != null ? typeof hybrid.refuge_options === "function" ? hybrid.refuge_options() : void 0 : void 0;
      ind = self.refugeSliceIndex;
      return self._increment(arr, ind, checkOnly);
    };
    this.getPrevRefuges = function(checkOnly) {
      var arr, hybrid, ind;
      if (checkOnly == null) {
        checkOnly = false;
      }
      hybrid = self.hybrid_selection();
      arr = hybrid != null ? typeof hybrid.refuge_options === "function" ? hybrid.refuge_options() : void 0 : void 0;
      ind = self.refugeSliceIndex;
      return self._decrement(arr, ind, checkOnly);
    };
    this.selectRefuge = function(refuge) {
      var ref;
      if (refuge.id === ((ref = self.refuge_selection()) != null ? ref.id : void 0)) {
        self.refuge_selection(null);
      } else {
        self.refuge_selection(refuge);
      }
      return self.saveSeedSelection();
    };
    this._increment = function(arr, ind, checkOnly) {
      return self._set(arr, ind, ind() + self.numResults, checkOnly);
    };
    this._decrement = function(arr, ind, checkOnly) {
      return self._set(arr, ind, ind() - self.numResults, checkOnly);
    };
    this._set = function(arr, ind, newInd, checkOnly) {
      var oldInd, rawNewInd, ref;
      rawNewInd = newInd;
      newInd = Math.max(Math.min(newInd, ((ref = arr != null ? arr.length : void 0) != null ? ref : 0) - self.numResults), 0);
      debugLog((arr != null ? arr.length : void 0) + ', ' + ind() + ', ' + rawNewInd + ', ' + newInd + ', ' + checkOnly);
      oldInd = ind();
      if (checkOnly !== true) {
        ind(newInd);
      }
      return oldInd === newInd;
    };
    this.field_name = EncodingUtils.htmlDecode(field.display_name);
    this.id = (ref = field.id) != null ? ref : null;
    this.fsr_id = (ref1 = field.fsr_id) != null ? ref1 : null;
    this.field_num = null;
    this.left_column = [];
    this.right_column = [];
    this.numResults = parent.numResults;
    this.hybrids = ko.observableArray([]);
    this.lowYieldHybrids = ko.observableArray([]);
    this.showSpinner = ko.observable(true);
    this.showError = ko.observable(false);
    this.hybridSliceIndex = ko.observable(0);
    this.visibleHybrids = ko.computed(function() {
      var ref2, sliceIndex;
      sliceIndex = self.hybridSliceIndex();
      return (ref2 = self.hybrids.slice(sliceIndex, sliceIndex + self.numResults)) != null ? ref2 : [];
    });
    this.hybrid_selection = ko.observable(null);
    this.hybrid_selection.subscribe(function(sel) {
      var hid, hids, i, vhids;
      hid = parseInt(sel != null ? sel.id : void 0);
      if (hid) {
        hids = (new TAFFY(self.hybrids()))().select('id');
        vhids = (new TAFFY(self.visibleHybrids()))().select('id');
        if (indexOf.call(hids, hid) >= 0 && indexOf.call(vhids, hid) < 0) {
          i = hids.indexOf(hid);
          return self.hybridSliceIndex(Math.floor(i / self.numResults) * self.numResults);
        }
      }
    });
    this.lowYieldHybridSliceIndex = ko.observable(0);
    this.visibleLowYieldHybrids = ko.computed(function() {
      var ref2, sliceIndex;
      sliceIndex = self.lowYieldHybridSliceIndex();
      return (ref2 = self.lowYieldHybrids.slice(sliceIndex, sliceIndex + self.numResults)) != null ? ref2 : [];
    });
    this.low_yield_hybrid_selection = ko.observable(null);
    this.low_yield_hybrid_selection.subscribe(function(sel) {
      var hid, hids, i, vhids;
      hid = parseInt(sel != null ? sel.id : void 0);
      if (hid) {
        hids = (new TAFFY(self.lowYieldHybrids()))().select('id');
        vhids = (new TAFFY(self.visibleLowYieldHybrids()))().select('id');
        if (indexOf.call(hids, hid) >= 0 && indexOf.call(vhids, hid) < 0) {
          i = hids.indexOf(hid);
          return self.lowYieldHybridSliceIndex(Math.floor(i / self.numResults) * self.numResults);
        }
      }
    });
    this.refugeSliceIndex = ko.observable(0);
    this.visibleRefuges = ko.computed(function() {
      var hybrid, ref2, ref3, sliceIndex;
      hybrid = self.hybrid_selection();
      if ((hybrid != null) && indexOf.call(self.visibleHybrids(), hybrid) < 0) {
        return [];
      }
      sliceIndex = self.refugeSliceIndex();
      return (ref2 = hybrid != null ? (ref3 = hybrid.refuge_options) != null ? ref3.slice(sliceIndex, sliceIndex + self.numResults) : void 0 : void 0) != null ? ref2 : [];
    });
    this.refuge_selection = ko.observable(null);
    this.refuge_selection.subscribe(function(sel) {
      var hid, hids, hybrid, i, vhids;
      hybrid = self.hybrid_selection();
      if ((hybrid == null) || ((hybrid != null) && indexOf.call(self.visibleHybrids(), hybrid) < 0)) {
        return;
      }
      hid = parseInt(sel != null ? sel.id : void 0);
      if (hid) {
        hids = (new TAFFY(hybrid.refuge_options))().select('id');
        vhids = (new TAFFY(self.visibleRefuges()))().select('id');
        if (indexOf.call(hids, hid) >= 0 && indexOf.call(vhids, hid) < 0) {
          i = hids.indexOf(hid);
          return self.refugeSliceIndex(Math.floor(i / self.numResults) * self.numResults);
        }
      }
    });
    this.planting_plan_id = ko.observable(null);
    this.rx_plan_id = ko.observable(null);
    this.hidden_planting_plan_id = ko.observable(null);
    this.plannedHybrids = ko.observableArray([]);
    return this;
  };

}).call(this);
